// extracted by mini-css-extract-plugin
export default {"ChangePwdModal_app":"changepwd_ChangePwdModal_app__5JtMJ","ChangePwd_title":"changepwd_ChangePwd_title__9ZiFo"};